
import { DivEmbedTargetFactory } from './div'
import { HTMLMediaEmbedTargetFactory } from './html-media'
import { VideoJSTargetFactory } from './video-js'
import { type DetectEmbedTargetsOptions, type EmbedTargetFactory } from './embed-target-factory'
import { JwPlayerTargetFactory } from './jwplayer'
import { type EmbedTarget } from './embed-target'
import { type EmbedBeforeCreateElementContext } from '../element-embedder'

const embedTargetList: Array<EmbedTargetFactory<EmbedTarget>> = [
  new JwPlayerTargetFactory(),
  new VideoJSTargetFactory(),
  new HTMLMediaEmbedTargetFactory(),
  new DivEmbedTargetFactory()
]

/**
   * Auto detects embed targets from the given DOM
   * @param options
   * @returns { embedTargetFactory: EmbedTargetFactory<EmbedTarget>, elements: HTMLElement[]} - list of detected embed targets and their elements
   */
export function detectEmbedTargetsFromDom (options: DetectEmbedTargetsOptions): Array<{
  embedTargetFactory: EmbedTargetFactory<EmbedTarget>
  elements: HTMLElement[]
}> {
  return embedTargetList.map(embedTargetFactory => {
    const elements = embedTargetFactory.detectFromDom(options)
    return {
      embedTargetFactory,
      elements
    }
  }).filter(i => i.elements != null && i.elements.length > 0)
}

export function getEmbedTargetFactory (name: string): EmbedTargetFactory<EmbedTarget> | undefined {
  return embedTargetList.find(i => i.name === name)
}

/**
   * Finds matching {@link EmbedTargetFactory} for the given {@link EmbedBeforeCreateElementContext}
   * @param ctx
   * @returns
   */
export function detectEmbedTargetFromContext (ctx: EmbedBeforeCreateElementContext): EmbedTargetFactory<EmbedTarget> | undefined {
  const match = embedTargetList.find(i => i.supports(ctx))
  return match
}
